module.exports = __webpack_public_path__ + "static/media/Group15.3bd32fe8.png";